function formatDateToSaoPauloTimezone(dateString) {
  if (!dateString) return null;

  const date = new Date(dateString);

  // Converter para timezone de São Paulo (America/Sao_Paulo)
  const saoPauloDate = new Date(date.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }));

  return (
    saoPauloDate.getFullYear() +
    '-' +
    String(saoPauloDate.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(saoPauloDate.getDate()).padStart(2, '0') +
    ' ' +
    String(saoPauloDate.getHours()).padStart(2, '0') +
    ':' +
    String(saoPauloDate.getMinutes()).padStart(2, '0') +
    ':' +
    String(saoPauloDate.getSeconds()).padStart(2, '0')
  );
}

export default formatDateToSaoPauloTimezone;
